import { Link, useForm, usePage } from '@inertiajs/react'
import FooterSearch from './FooterSearch'

// ページの末尾に置く。中身は app/views/shared/_footer.html.erb とそろえる
export default function Footer({ hideLetter = false }) {
  const { site_title, current_user } = usePage().props

  return (
    <footer className="bg-[#FE8EC6] text-white">
      <div className="max-w-[680px] mx-auto px-4 pt-8 pb-7 flex flex-col gap-7">
        {!hideLetter && (
          <>
            <LetterSection currentUser={current_user} />
            <hr className="border-white/45" />
          </>
        )}

        <FooterSearch />

        <nav className="flex flex-wrap gap-x-5 gap-y-2 text-sm" aria-label="Footer">
          <Link href="/" className="hover:underline">Home</Link>
          <a href="/topics" className="hover:underline">Topics</a>
          <a href="/pawprints" className="hover:underline">Pawprints</a>
          <a href="/feed.xml" className="hover:underline">Feed</a>
          <a href="/pages/privacy" className="hover:underline">Privacy</a>
          {current_user ? (
            <Link href="/settings" className="hover:underline">Settings</Link>
          ) : (
            <Link href="/sessions/new" className="hover:underline">Login</Link>
          )}
        </nav>

        <Link href="/" className="flex items-center gap-2.5 text-xs">
          <img src="/juneboku-icon.png" alt="" className="w-9 h-9 rounded" style={{ animation: 'none' }} onMouseEnter={e => e.currentTarget.style.animation = 'wiggle 0.5s ease-in-out'} onAnimationEnd={e => e.currentTarget.style.animation = 'none'} />
          <span>{site_title}<br />生活者junebokuの日記とメモ。2019年8月23日から。</span>
        </Link>
      </div>
    </footer>
  )
}

function LetterSection({ currentUser }) {
  const { data, setData, post, processing } = useForm({ email: '' })

  const submit = (e) => {
    e.preventDefault()
    post('/sessions')
  }

  if (currentUser?.letter_subscribed) {
    return (
      <section>
        <h2 className="text-lg font-semibold mb-1.5">Letter</h2>
        <p className="text-sm leading-relaxed">レターを購読中です。毎週日曜日ごろに届きます。</p>
        <div className="mt-3.5 flex flex-wrap items-center gap-x-4 gap-y-3">
          <Link href="/settings" className="inline-block rounded-lg px-4 py-2 text-sm font-semibold ring-[1.5px] ring-inset ring-white hover:bg-white/10">Settings</Link>
          <LoggedInAs user={currentUser} />
        </div>
      </section>
    )
  }

  if (currentUser) {
    return (
      <section>
        <h2 className="text-lg font-semibold mb-1.5">Letter</h2>
        <p className="text-sm leading-relaxed">毎週日曜日ごろ、1週間の様子をレターとしてメールでお届けしています。ここで日記に書いていることより少し踏み込んだ内容を書くこともあります。日記を読んでくれている人には、ぜひ受け取ってほしいです。いまは配信オフになっています。</p>
        <div className="mt-3.5 flex flex-wrap items-center gap-x-4 gap-y-3">
          <Link href="/settings" className="inline-block rounded-lg bg-white px-4 py-2 text-sm font-semibold text-pink-500 hover:bg-pink-50">Turn on in Settings</Link>
          <LoggedInAs user={currentUser} />
        </div>
      </section>
    )
  }

  return (
    <section>
      <h2 className="text-lg font-semibold mb-1.5">Letter</h2>
      <p className="text-sm leading-relaxed mb-3.5">毎週日曜日ごろ、1週間の様子をレターとしてメールでお届けしています。ここで日記に書いていることより少し踏み込んだ内容を書くこともあります。日記を読んでくれている人には、ぜひ受け取ってほしいです。</p>
      <form onSubmit={submit} className="flex flex-wrap gap-2">
        <input
          type="email"
          value={data.email}
          onChange={(e) => setData('email', e.target.value)}
          required
          placeholder="mazzel-daisuki@example.com"
          aria-label="Email address"
          className="flex-[1_1_12rem] min-w-0 rounded-lg bg-white/90 px-3 py-2 text-gray-900 placeholder-gray-400 focus:bg-white focus:outline-none"
        />
        <button
          type="submit"
          disabled={processing}
          className="rounded-lg bg-white px-4 py-2 text-sm font-semibold text-pink-500 hover:bg-pink-50 disabled:opacity-50"
        >
          Subscribe
        </button>
      </form>
      <p className="mt-2 text-xs">登録用のリンクがメールで届きます。パスワードは要りません。</p>
    </section>
  )
}

function LoggedInAs({ user }) {
  return (
    <span className="inline-flex items-center gap-2 text-sm">
      <img src={user.gravatar_url} alt="" className="w-6 h-6 rounded-full" />
      <span>Logged in as {user.display_name}</span>
    </span>
  )
}
